<template>
  <a-card :bordered='false'>
    <a-button type="primary" v-has:antiBackAdd="()=> {$router.push('/antiFleeingGoods/backManage/backOrderAdd?type=add')}">
      <PlusOutlined />
      创建退货单
    </a-button>
    <a-tabs class='m-t-10' v-model:activeKey="search.refund_type" @change='pageSearchChange'>
      <a-tab-pane :key="1" tab="经销商退货" :disabled='listLoading'></a-tab-pane>
      <a-tab-pane :key="2" tab="门店退货" :disabled='listLoading'></a-tab-pane>
    </a-tabs>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="sn">退货单号</a-select-option>
            <a-select-option value="from">退货人</a-select-option>
            <a-select-option value="mobile">退货人手机号</a-select-option>
            <a-select-option value="product_name">退货商品名称</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="退回仓库" name='refund_warehouse_id'>
        <a-select v-model:value="search.refund_warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
        <a-button type="primary" ghost  class="m-l-15" v-has:antiBackExport="()=>{exportOpen()}">导出</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='refund_warehousing_sn' :columns='columns' :data-source='list' class="tableFixBox m-t-20" :scroll="{ x: 'max-content'}">
      <template v-slot:product_name="{ record }">
        <div v-if='record.product.length == 1' >
          <div v-for="(item,index) in record.product" :key='index'>
            <a-card-meta>
              <template #description>   {{!item.product_sku_name || item.product_sku_name=='0' ? '单规格':item.product_sku_name}} - {{item.product_name}}</template>
            </a-card-meta>
          </div>
        </div>
        <div class="s_flex_ali" v-else>
          <p class="m-l-5 m-r-10">多商品</p>
          <a-button type="primary" size="small" @click='targetList=record.product;goodDetailVisible=true'>查看商品详情</a-button>
        </div>
      </template>
      <template #title_num>
        退货数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:refund="{ record }">
        <p>{{record.to ? record.to:'-'}}</p>
        {{record.to_mobile}}
      </template>
         <template v-slot:returnQuantity="{ record }">
           <p @click="codeDetailVisible=true;targetId=record.refund_warehousing_sn" class="cursor_p" style="color:#f04635;cursor: pointer;">{{record.return_quantity || '-'}}</p>
         </template>
      <template v-slot:action="{ record }">
        <a v-has:antiBackDetail="()=>{targetId=record.refund_warehousing_sn;orderDetailVisible=true}" href="javascript:;">查看详情</a>
        <!-- <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a @click="targetId=record.refund_warehousing_sn;orderDetailVisible=true" href="javascript:;">查看详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="()=> {$router.push('/antiFleeingGoods/backManage/backOrderAddGoods?type=edit&id='+record.refund_warehousing_sn)}"
                  href="javascript:;">添加商品</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click='del(record.refund_warehousing_sn)'>删除</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown> -->
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
   <a-modal title='退货二维码明细' :keyboard="false" :maskClosable='false' v-model:visible="codeDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
      <codeDetail  :id="targetId"/>
  </a-modal>
  <a-modal title='商品详情' :keyboard="false" :maskClosable='false' v-model:visible="goodDetailVisible" destroyOnClose :footer='null' :width="1200" centered>
    <goodDetail  :listdata="targetList"/>
</a-modal>
<a-modal title='退货单详情' :keyboard="false" :maskClosable='false' v-model:visible="orderDetailVisible" destroyOnClose :footer='null' :width="800" centered>
  <backOrderDetails  :id="targetId" type='list'/>
</a-modal>

<!-- 导出 -->
    <a-modal :keyboard="false" title="导出"  v-model:visible="exportVisble" centered :footer="null" :width='500' destroyOnClose>
        <div>
          <div class="s_flex_ali">
            <span>创建时间：</span>
              <a-range-picker v-model:value="exportTime" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD'/>
          </div>
          <p style="font-size:14px;color:#999;margin-left:75px" class="m-t-10">导出筛选后的数据，创建时间间距不能大于31天</p>
          <a-button type="primary" class="m-t-40" style="margin-left:50%;transform:translateX(-50%)" @click="exportTable">导出</a-button>
        </div>
    </a-modal>
</template>
<script>
  import { InfoCircleOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted } from "vue";
  import { message,Modal } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getRouter } from "@/utils/app";
  import { getPageState } from "@/utils/pageState";
  import useTableSearch from "@/hooks/useTableSearch";
  import codeDetail from './components/codeDetail'
  import goodDetail from '../components/goodDetails.vue'
  import backOrderDetails from '../components/backOrderDetails.vue'
  import { getRefundOrder,getWarehouseList,delRefundOrder,refundExport } from "@/api/antiFleeing";
  import store from "@/store";
  import moment from 'moment';
  import config from "@/config";
  const defSearch = {
    page: 1,
    limit: 10,
    keyword: "",
    key_type:"sn",
    refund_warehouse_id: "",
    start_time: "",
    end_time: "",
    refund_type:1
  };
  export default {
    components: {InfoCircleOutlined,PlusOutlined,codeDetail,goodDetail,backOrderDetails},
    setup() {
      const state = reactive({
        info: store.state.user.info,
        time: [],
        warehouseList:[],
        targetList:[],
        goodDetailVisible:false,
        orderDetailVisible:false,
        exportVisble:false,
        exportTime:[]
      });
      let columns = [
        {
          title: "退货单号",
          dataIndex: "refund_warehousing_sn",
          key: "refund_warehousing_sn",
        },
        {
          title: "商品信息",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "退回仓库",
          dataIndex: "refund_warehouse_name",
          key: "refund_warehouse_name",
        },
        {
          dataIndex: "return_quantity",
          key: "return_quantity",
          slots: { title: 'title_num',customRender:"returnQuantity" }
        },
        {
          title: "退货人",
          dataIndex: "refund",
          key: "refund",
          slots: { customRender: "refund" },
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          key: "create_time",
        },
        {
          title: "注备",
          dataIndex: "remark",
          key: "remark"
        },
        {
          title: "操作",
          key: "action",
          fixed:"right",
          slots: { customRender: "action" },
        },
      ];
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data).catch(error => error);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      // 删除
      const del = (id) => {
        Modal.confirm({
          centered: true,
          title:'是否删除退货单？',
          content: "删除商品后，退货单中所有商品归属权返还到退货人中，进行拆箱退货的中标和大标依然无效",
          onOk: async () => {
            let res = await delRefundOrder(id).then((res) => res.data).catch(error => error);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
          // 查看二维码详情
    const codeDetailVisible=ref(false)
    const targetId=ref('');
    //
    const exportOpen = function(){
       if(state.time[0]){
             state.exportTime = state.time;
          }else{
            state.exportTime = [moment().subtract(30, 'days'), moment()];
          }
          state.exportVisble = true;
    }

     //导出
       const exportTable = async function(){
                let dataNum = moment(state.exportTime[1]).diff(moment(state.exportTime[0]),'days')+1;
                   if(dataNum>31){
                      message.error('时间间距不能大于31天！')
                   }else{
                       const hide = message.loading('正在加载中...', 0);
                       let result=await refundExport( { ...search.value, limit: 5000,excel:1,start_time:moment(state.exportTime[0]).format('YYYY-MM-DD'),end_time:moment(state.exportTime[1]).format('YYYY-MM-DD') }).then(res=>res.data).catch(error=>error);
                        setTimeout(hide);
                        if(iscode(result,true)){
                           window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key);
                            state.exportVisble = false;
                        }
                   }
       }

    

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(getRefundOrder, search.value);
        getWarehouse();
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        del,
        codeDetailVisible,
        targetId,
        exportOpen,
        exportTable
      };
    },
  };
</script>